<!-- <div class="col-md-12 row">
    <ng-template dynamicComponentPlaceHolder></ng-template>
</div> -->
 

<!-- RADIO BUTTON -->
<div class="col-md-12 pr-0">
    <p>Would you like to use system generated letter or upload your own letter?</p> 

    <div class="col-6 float-left">
      <div class="row">
        <p-radioButton name="generateForm" (onClick)="handleGenerateForm(true)"
          [(ngModel)]="isGenerated" [value]="true" class="letter-radio" label="Generate Letter"> 
        </p-radioButton>
      </div>
    </div>

    <div class="col-6 float-left">
        <div class="row">
            <p-radioButton name="generateForm" (onClick)="handleGenerateForm(false)"
            [(ngModel)]="isGenerated" [value]="false" label="Upload Letter" class="letter-radio">
            </p-radioButton>
        </div>
        <div class="clearfix"></div>
    </div>
</div>

<div class="clearfix"></div>
    
<!-- UPLOAD LETTER -->
<div class="row" *ngIf="!isGenerated">
    <div class="col-6"></div>
    <div class="col-6">
        <div class="upload-btn-wrapper">
                <button class="btn-success btn" [disabled]="disabledControls">Upload a file</button>
                <input #myfile type="file" name="myfile" [disabled]="disabledControls" (change)="uploadForm($event.target.files)" />
        </div>
        <div class="supportFileText">(Supported file type: .pdf)</div> 
    </div>
</div> 

<div class="col-12">
    <table class="im-card-no-border-table file-upload-list table-striped-simple" style="margin-top: 20px; width: 100%;"
    *ngIf="!(isGenerated) && (isUploaded)">
        <thead style="height: 30px;">
            <tr>
            <th>Document Type</th>
            <th>Document Name</th>
            <th>Uploaded On</th>
            <th class="text-center">
                Actions
            </th>
            </tr>
        </thead>
        <tbody>
            <tr>
            <td>
                <strong>Support Letter</strong>
            </td>
            <td nowrap>
            {{uploadedFileName}}
            </td>
            <td nowrap>
            {{generatedOn}}
            </td>
            <td nowrap>
                <div class="d-flex flex-row align-items-center justify-content-center">
                <div class="mr-2 padding0">
                    <mat-icon class="mr-1 icn" pTooltip="View"
                        class="material-icons"  (click)="viewDocument(fileSrc)" >visibility</mat-icon>
                </div>

                <div class="mr-2 padding0">
                    <span>
                    <mat-icon class="mr-1 icn"  [ngClass]="{'disabled': disabledControls}" pTooltip="Delete" class="material-icons" (click)="deleteUploadedDocument(documentId)">delete</mat-icon>
                    </span>
                </div>
                </div>
            </td>
            </tr>
        </tbody>
    </table>
</div>

<div class="clearfix"></div>

<!-- LETTER CONTENT -->
<div   style="margin-top:25px;" class="col-md-12 pr-0" [ngClass]="{'visible': isGenerated, 'invisible': !isGenerated}">       
    <ng-template dynamicComponentPlaceHolder ></ng-template> 
</div>